/**
 * 3.111 (the sponsor's ruling on the provisional batch, 2026-10-08, fix 8):
 * a machine class name as a reader would write it, acronyms kept whole.
 * "sql-injection" -> "SQL injection", "http-differential" -> "HTTP
 * differential", "broken-object-level-authorization" -> "Broken object level
 * authorization". Engine-derived input, so plain text out, never markup
 * (invariant 9).
 */
const ACRONYMS: Record<string, string> = {
  ai: "AI", api: "API", asp: "ASP", cors: "CORS", crlf: "CRLF", csp: "CSP", csrf: "CSRF", cve: "CVE", cwe: "CWE",
  dns: "DNS", ftp: "FTP", graphql: "GraphQL", hsts: "HSTS", html: "HTML", http: "HTTP", https: "HTTPS", id: "ID",
  idor: "IDOR", ip: "IP", js: "JS", json: "JSON", jwt: "JWT", ldap: "LDAP", lfi: "LFI", nosql: "NoSQL", oauth: "OAuth",
  oob: "OOB", os: "OS", owasp: "OWASP", php: "PHP", rce: "RCE", rfi: "RFI", saml: "SAML", smtp: "SMTP", sql: "SQL",
  ssh: "SSH", ssl: "SSL", ssrf: "SSRF", ssti: "SSTI", tls: "TLS", url: "URL", xml: "XML", xss: "XSS", xxe: "XXE",
};

/**
 * 3.132: the compounds English writes with a hyphen, so "cross-site-scripting"
 * reads "Cross-site scripting" and not "Cross site scripting". The first
 * letter's case is kept, whatever position the compound is in.
 */
const COMPOUNDS: [RegExp, string][] = [
  [/\b([Cc])ross site\b/g, "$1ross-site"],
  [/\b([Ss])erver side\b/g, "$1erver-side"],
  [/\b([Cc])lient side\b/g, "$1lient-side"],
];

export function classLabel(cls: string): string {
  const words = cls.replace(/[-_]+/g, " ").trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return cls;
  const label = words
    .map((w, i) => {
      const lower = w.toLowerCase();
      if (Object.prototype.hasOwnProperty.call(ACRONYMS, lower)) return ACRONYMS[lower];
      return i === 0 ? lower[0].toUpperCase() + lower.slice(1) : lower;
    })
    .join(" ");
  return COMPOUNDS.reduce((s, [re, to]) => s.replace(re, to), label);
}

/**
 * 3.111 (fix 7): users choose scan profiles, never engines (invariant 14), so
 * an engine-derived sentence that LEADS with the engine's name loses it:
 * "SQLMap boolean-based blind payload" -> "Boolean-based blind payload". Only
 * a leading name is removed; the rest is the platform's words, untouched.
 */
const LEADING_ENGINE =
  /^(?:nuclei|wapiti|sqlmap|dalfox|wpscan|strix|katana|feroxbuster|httpx|interactsh|subfinder|naabu|wappalyzer(?:go)?)\b[\s:,-]*/i;

export function withoutLeadingEngine(text: string): string {
  const out = text.replace(LEADING_ENGINE, "");
  if (out === text || out === "") return text;
  return out[0].toUpperCase() + out.slice(1);
}
